import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from "react-localize-redux";
import { PngFlag } from '../../common/pngFlag';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { hasPermission, apiPost, getHostApi, getHostUrl } from '../../../store/apiWrapper';
import RelationLink from '../relations/relationLink';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import ResponsiveTable from "../../layoutItems/responsiveTable";
import XlsxExport from '../../../img/icons/BBicons_Export-XLSX';
import DownloadFileButton from "../../files/downloadFileButton";

import "./economicGroup.scss"

class EconomicGroupSme extends React.Component {

    state = {
        guid: null,
        canPrepareExport: true
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (this.state.guid != prevState.guid && !this.state.canPrepareExport) {
            this.setState({ canPrepareExport: true })
        }
    }

    render() {
        return (isNullOrUndefined(this.props.data) ? "" : this.renderContent(this.props.data));
    }

    renderContent = (data) => {
        const perm = hasPermission(null, "MSPEvaluationLimited");
        return (
            <div className="columns is-multiline">
                <div className="column is-12">
                    {(!isNullOrUndefined(this.props.customizableMspImportData) && !this.props.customizableMspImportData.hasItems) && <OldStyleTableWithHistory tableColumns={4} actualData={[data]} stripped resolveExpanded={this.props.resolveExpanded}
                        head={() => <thead>
                            <tr>
                                <th><Translate id="Report.EconomicGroup.SME.PublicAuthorityShare" /></th>
                                <th><Translate id="Report.EconomicGroup.SME.PartnerCompanyCount" /></th>
                                <th><Translate id="Report.EconomicGroup.SME.AssociatedCompanyCount" /></th>
                                {<th className={classnames({ "limited": perm })}><Translate id="Report.EconomicGroup.SME.AssociatedCompanyInPartnerCompanyCount" /></th>}
                            </tr>
                        </thead>}
                        actualRow={(r) => <tr key={1}>
                            <td>{r.publicAuthorityShare ? <Translate id="Common.Yes" /> : <Translate id="Common.No" />}</td>
                            <td>{r.partnerCompanyCount}</td>
                            <td>{r.associatedCompanyCount}</td>
                            {<td className={classnames({ "limited": perm })}>{r.associatedCompanyInPartnerCompanyCount}</td>}
                        </tr>}
                    />}
                    {(!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.hasItems) && <OldStyleTableWithHistory tableColumns={4} actualData={[this.props.customizableMspImportData]} stripped resolveExpanded={this.props.resolveExpanded}
                        head={() => <thead>
                            <tr>
                                <th><Translate id="Report.EconomicGroup.SME.PublicAuthorityShare" /></th>
                                <th><Translate id="Report.EconomicGroup.SME.AssociatedCompanyCount" /></th>
                                <th><Translate id="Report.EconomicGroup.SME.PartnerAndLinkedEnterprises" /></th>
                            </tr>
                        </thead>}
                        actualRow={(r) => <tr key={1}>
                            <td>-</td>
                            <td>{r.associatedCompanyCount}</td>
                            <td>{r.partnersAndAssociatedPartnersCount}</td>
                        </tr>}
                    />}
                    <div style={{ padding: "1.5em 0em" }}>
                        <span className="underlined-title-wrapper">
                            <span className="underlined-title">
                                <Translate id="Report.EconomicGroup.Settings.EconomicGroup" />
                            </span>
                        </span>
                    </div>
                    {this.renderRelations(data.relations)}

                    {(!isNullOrUndefined(this.props.customizableMspImportData) && !this.props.customizableMspImportData.hasItems) && <div style={{ padding: "2em 0em" }}>
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedEmployeesCount"), data.employees, 241, 0.0932, 23.5)}
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedTurnover"), data.turnover, 49000000, 0.11512, 120)}
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedAssets"), data.assets, 42000000, 0.11512, 120)}
                        {this.renderEvaluationSmeTable(this.props.translate("Report.EconomicGroup.SME.Total"), data.microFinalProbability, data.smallFinalProbability, data.mediumFinalProbability, data.largeFinalProbability)}
                        {hasPermission(null, "EvaluationMidCaps") && this.renderMidCapTable(this.props.translate("Report.EconomicGroup.MSP.Evaluation"), data.midCapText, 100 - (data.largeFinalProbability * 100), data.smallMidCap * 100, data.midCap * 100)}
                    </div>
                    }

                    {(!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.hasItems) && <div style={{ padding: "2em 0em" }}>
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedEmployeesCount"), this.props.customizableMspImportData.employees, 241, 0.0932, 23.5)}
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedTurnover"), this.props.customizableMspImportData.turnover, 49000000, 0.11512, 120)}
                        {this.renderTableWithGraph(this.props.translate("Report.EconomicGroup.SME.ComputedAssets"), this.props.customizableMspImportData.assets, 42000000, 0.11512, 120)}
                        {this.renderEvaluationSmeTable(this.props.translate("Report.EconomicGroup.SME.Total"), this.props.customizableMspImportData.microFinalProbability, this.props.customizableMspImportData.smallFinalProbability, this.props.customizableMspImportData.mediumFinalProbability, this.props.customizableMspImportData.largeFinalProbability)}
                        {hasPermission(null, "EvaluationMidCaps") && this.renderMidCapTable(this.props.translate("Report.EconomicGroup.MSP.Evaluation"), this.props.customizableMspImportData.midCapText, 100 - (this.props.customizableMspImportData.largeFinalProbability * 100), this.props.customizableMspImportData.smallMidCap * 100, this.props.customizableMspImportData.midCap * 100)}
                    </div>}
                    {(!isNullOrUndefined(this.props.customizableMspImportData) && !this.props.customizableMspImportData.hasItems) && <ExcelExportButton link="economic-group-sme" entityId={this.props.id} report={this.props.reportType} />}
                    {(!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.hasItems) && <div style={{ fontSize: "0.9em", ...this.props.style }} className="print-hidden is-hidden-mobile">
                        <span onClick={(e) => this.prepareExcelFile(e)} style={{ display: "flex", marginRight: "auto", cursor: "pointer" }}>
                            <XlsxExport className="svg-standard-fill icon-centered export-icon" style={{ width: "1.5em", height: "1.5em", cursor: 'pointer' }} />
                            <span className="link-external" style={{ marginLeft: "0.5em", cursor: 'pointer' }}>
                                <DownloadFileButton style={{ display: 'none' }} id='customizable-msp-excel-download' />
                                <Translate id="Common.ExportToExcel" />
                            </span>
                        </span>

                    </div>}
                </div>
            </div>
        )
    }


    prepareExcelFile = (e) => {
        let data = this.props.customizableMspImportData;

        if (this.state.canPrepareExport) {
            this.setState({ canPrepareExport: false }, () => {
                apiPost(`${getHostApi()}/api/excel-export/customizable-msp/prepare-excel/${this.props.id}`, null, data,
                    (s) => this.pressDownloadButton(s.data),
                    (e) => this.onError("Common.Error"));
            });
        }
    }

    pressDownloadButton = (guid) => {
        this.setState({ guid: guid }, () => {
            let link = document.getElementById(`customizable-msp-excel-download`);
            link.href = `${getHostUrl()}/files/customizable-msp/file/${this.state.guid}`;
            link.target = '_blank';
            link.click();
        });
    }


    renderRelations = (relations) => {
        if (!isNullOrUndefined(this.props.customizableMspImportData) && this.props.customizableMspImportData.hasItems) {
            return <ResponsiveTable>
                <OldStyleTableWithHistory tableColumns={6} actualData={this.props.customizableMspImportData.items.map((r, i) => ({ ...r, index: i }))} stripped
                    resolveExpanded={this.props.resolveExpanded}
                    classNames={{ "ess-table": true, "with-ellipsed-column": true }}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="Report.EconomicGroup.EconomicGroupLevel" /></th>
                            <th style={{ width: "12.64%" }}><Translate id="Report.EconomicGroup.SME.EmployeesCount" /></th>
                            <th style={{ width: "12.64%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.Turnover" /></th>
                            <th style={{ width: "12.64%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.Assets" /></th>
                            <th style={{ width: "9%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.EvaluationWeight" /></th>
                            <th style={{ width: "16.17%" }}><Translate id="Report.EconomicGroup.SME.Relation" /></th>
                        </tr>
                    </thead>}
                    actualRow={(r) => this.renderCustomLayerRow(r)}
                />
            </ResponsiveTable>
        }

        if (isNullOrUndefined(relations) || relations.length === 0)
            return null;

        return (
            <ResponsiveTable>
                <OldStyleTableWithHistory tableColumns={6} actualData={relations.map((r, i) => ({ ...r, index: i }))} stripped
                    resolveExpanded={this.props.resolveExpanded}
                    classNames={{ "ess-table": true, "with-ellipsed-column": true }}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="Report.EconomicGroup.EconomicGroupLevel" /></th>
                            <th style={{ width: "12.64%" }}><Translate id="Report.EconomicGroup.SME.EmployeesCount" /></th>
                            <th style={{ width: "12.64%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.Turnover" /></th>
                            <th style={{ width: "12.64%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.Assets" /></th>
                            <th style={{ width: "9%", textAlign: "right" }}><Translate id="Report.EconomicGroup.SME.EvaluationWeight" /></th>
                            <th style={{ width: "16.17%" }}><Translate id="Report.EconomicGroup.SME.Relation" /></th>
                        </tr>
                    </thead>}
                    actualRow={(r) => this.renderLayerRow(r)}
                />
            </ResponsiveTable>
        );
    }

    renderCustomLayerRow = (data) => {
        if (data === undefined || data === null || data.length === 0)
            return null;

        const { level, index, assets, assetsRate, currency, birthDate, birthDateFormatted, companyId, countryCode, country, employeesMin, employeesMax, relation, strength, subjectName, subjectType, turnoverMin, turnoverMax, turnoverRate } = data;
        let identifier = isNullOrUndefined(companyId) ? isNullOrUndefined(birthDate) ? "" : birthDateFormatted : companyId;

        return (
            <tr key={index} className='group-sme-relations-row colorize'>
                {level === 0 && <td data-level={level} className='ellipsed-column' data-label={this.props.translate('Report.EconomicGroup.EconomicGroupLevel')}>
                    <div style={{ display: 'flex', flexWrap: "nowrap" }} data-level={level}>
                        <RelationLink entityName={subjectName} showOnMobile={true} />
                        &nbsp;<PngFlag countryCode={countryCode} title={country} />&nbsp;{identifier && `(${identifier})`}

                    </div>
                </td>}
                {/* {Array.from(Array(maxLevel).keys()).map(x => <td key={x} data-level={x + 1}>{data.level === x ?  : "⇨"}</td>)} */}
                {level !== 0 && <td data-level={level} className='ellipsed-column' data-label={this.props.translate('Report.EconomicGroup.EconomicGroupLevel')}>
                    <div style={{ display: 'flex', flexWrap: "nowrap" }} data-level={level}>
                        <RelationLink entityName={subjectName} showOnMobile={true} />
                        &nbsp;<PngFlag countryCode={countryCode} title={country} />&nbsp;{identifier && `(${identifier})`}
                    </div>
                </td>}
                {employeesMin === employeesMax && <td className="desktop-center" data-label={this.props.translate('Report.EconomicGroup.SME.EmployeesCount')}>{this.formatNumber(employeesMin)}</td>}
                {employeesMin !== employeesMax && <td className="desktop-center" data-label={this.props.translate('Report.EconomicGroup.SME.EmployeesCount')}>{this.formatNumber(employeesMin)} - {this.formatNumber(employeesMax)}</td>}
                {turnoverMin === turnoverMax && <td className="col-4" data-label={this.props.translate('Report.EconomicGroup.SME.Turnover')}>{turnoverMin && `${this.formatNumber(turnoverMin)} ${this.localizeCurrency(currency)}`}</td>}
                {turnoverMin !== turnoverMax && <td className="col-4" data-label={this.props.translate('Report.EconomicGroup.SME.Turnover')}>{turnoverMin && `${this.formatNumber(turnoverMin)} - ${this.formatNumber(turnoverMax)} ${this.localizeCurrency(currency)}`}</td>}
                <td className="col-5" data-label={this.props.translate('Report.EconomicGroup.SME.Assets')}>{assets && `${this.formatNumber(assets)} ${this.localizeCurrency(currency)}`}</td>
                <td className="col-6" data-label={this.props.translate('Report.EconomicGroup.SME.EvaluationWeight')}>{strength && `${(strength * 100).toFixed(0)}%`}</td>
                <td data-label={this.props.translate('Report.EconomicGroup.SME.Relation')}>{relation && `${relation}`}</td>
            </tr>
        );
    }

    localizeCurrency(currency) {
        if (isNullOrUndefined(currency))
            return "";
        if (currency === "CZK" || currency === "SKK" || currency === "EUR")
            return this.props.translate(`Common.Currency.${currency}`);

        return currency;
    }

    formatNumber = (num) => isNullOrUndefined(num) ? "" : num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");


    renderLayerRow = (data) => {
        if (data === undefined || data === null || data.length === 0)
            return null;

        const { entityId, fullName, reports, countryCode, country, currency, identifier, employees, turnover, assets, shareFuzzy, ownerType, share, index } = data;
        return (
            <tr key={index} className='group-sme-relations-row colorize'>
                {data.level === 0 && <td data-level={data.level} className='ellipsed-column' data-label={this.props.translate('Report.EconomicGroup.EconomicGroupLevel')}>
                    <div style={{ display: 'flex', flexWrap: "nowrap" }} data-level={data.level}>
                        <RelationLink entityId={entityId} reports={reports} entityName={fullName} showOnMobile={true} />
                        &nbsp;<PngFlag countryCode={countryCode} title={country} />&nbsp;{identifier && `(${identifier})`}
                    </div>
                </td>}
                {/*Array.from(Array(maxLevel).keys()).map(x => <td key={x} data-level={x + 1}>{data.level === x ?  : "⇨"}</td>)*/}
                {data.level !== 0 && <td data-level={data.level} className='ellipsed-column' data-label={this.props.translate('Report.EconomicGroup.EconomicGroupLevel')}>
                    <div style={{ display: 'flex', flexWrap: "nowrap" }} data-level={data.level}>
                        <RelationLink entityId={entityId} reports={reports} entityName={fullName} showOnMobile={true} />
                        &nbsp;<PngFlag countryCode={countryCode} title={country} />&nbsp;{identifier && `(${identifier})`}
                    </div>
                </td>}
                <td className="desktop-center" data-label={this.props.translate('Report.EconomicGroup.SME.EmployeesCount')}>{employees}</td>
                <td className="col-4" data-label={this.props.translate('Report.EconomicGroup.SME.Turnover')}>{turnover}</td>
                <td className="col-5" data-label={this.props.translate('Report.EconomicGroup.SME.Assets')}>{assets && `${assets} ${this.localizeCurrency(currency)}`}</td>
                <td className="col-6" data-label={this.props.translate('Report.EconomicGroup.SME.EvaluationWeight')}>{shareFuzzy && `${shareFuzzy}%`}</td>
                <td data-label={this.props.translate('Report.EconomicGroup.SME.Relation')}>{ownerType && `${ownerType} (${share}%)`}</td>
            </tr>
        );
    }

    renderTableWithGraph = (label, data, start, coef, shift) => {
        return (
            <>
                <table className="table-economic-group-graph" style={{ width: "100%" }}>
                    <colgroup>
                        <col width="33%" />
                        <col width="7%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="15%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px" }}>{label}</th>
                            <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>0</th>
                            <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                                <div className="hide-on-desktop">
                                    {this.shortNumber(data.microLimit, 1)}
                                </div>
                                <div className="hide-on-mobile">
                                    {data.microLimit}
                                </div>
                            </th>
                            <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                                <div className="hide-on-desktop">
                                    {this.shortNumber(data.smallLimit, 1)}
                                </div>
                                <div className="hide-on-mobile">
                                    {data.smallLimit}
                                </div>
                            </th>
                            <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                                <div className="hide-on-desktop">
                                    {this.shortNumber(data.mediumLimit, 1)}
                                </div>
                                <div className="hide-on-mobile">
                                    {data.mediumLimit}
                                </div>
                            </th>
                            <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                                <div style={{ lineHeight: "1em", fontSize: "1.5em" }}>
                                    {'∞'}
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px", fontWeight: 'normal' }}>{data.range}</th>
                            <td></td>
                            <td className="micro-ess-column">
                                <div className="micro-ess-slider" style={this.setSizeOfSlider(data.min, data.max, 0, data.microLimit)}></div>
                            </td>
                            <td className="small-ess-column">
                                <div className="small-ess-slider" style={this.setSizeOfSlider(data.min, data.max, data.microLimit, data.smallLimit)}></div>
                            </td>
                            <td className="medium-ess-column">
                                <div className="medium-ess-slider" style={this.setSizeOfSlider(data.min, data.max, data.smallLimit, data.mediumLimit)}></div>
                            </td>
                            <td className="large-ess-column">
                                <div className="large-ess-slider" style={this.setSizeOfLastSlider(data.min, data.max, data.mediumLimit, data.largeLimit, start, coef, shift)}></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr className="economic-group" />
            </>
        )
    }

    renderEvaluationSmeTable = (label, micro, small, medium, large) => {
        return (
            <table className="table-economic-group-graph" style={{ width: "100%" }}>
                <colgroup>
                    <col width="33%" />
                    <col width="7%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                </colgroup>
                <thead>
                    <tr>
                        <th style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px" }}>{label}</th>
                        <td></td>
                        <td className="micro-ess-column">

                            <div className={classnames({ "final-evaluation-column": true, "micro-ess-evaluation": micro > 0, "is-start": micro > 0, "is-end": small === 0 })}>
                                <Translate id="Report.EconomicGroup.SME.MicroEnterprise" />
                            </div>
                        </td>
                        <td className="small-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "small-ess-evaluation": small > 0, "is-start": small > 0 && medium > 0, "is-end": micro > 0 && medium === 0 })}>
                                <Translate id="Report.EconomicGroup.SME.SmallEnterprise" />
                            </div>
                        </td>
                        <td className="medium-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "medium-ess-evaluation": medium > 0, "is-start": medium > 0 && large > 0, "is-end": small > 0 && large === 0 })}>
                                <Translate id="Report.EconomicGroup.SME.MediumEnterprise" />
                            </div>
                        </td>
                        <td className="large-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "large-ess-evaluation": large > 0, "is-start": medium === 0, "is-end": medium > 0 })}>
                                <Translate id="Report.EconomicGroup.SME.NotSme" />
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className={this.setEvaluationColor(large)} style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px" }}>{this.isSME(large)}</th>
                        <td></td>
                        <td className="ess-table-evaluation">
                            {parseFloat(micro * 100).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(small * 100).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(medium * 100).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(large * 100).toFixed(2) + "%"}
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    renderMidCapTable = (label, midCapText, msp, smallMidCap, midCap) => {
        let notMidCap = Number(100 - msp - smallMidCap - midCap).toFixed(2);
        let midCapValue = ((100 - smallMidCap - midCap) / 100).toFixed(2);
        let evalColorValue = midCapValue > 0 ?  midCapValue < 1 ? 0.5 : 1 : 0;

        return (
            <table className="table-economic-group-graph" style={{ width: "100%" }}>
                <colgroup>
                    <col width="33%" />
                    <col width="7%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                    <col width="15%" />
                </colgroup>
                <thead>
                    <tr>
                        <th style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px" }}>{label}</th>
                        <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}></th>
                        <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}></th>
                        <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                            <div className="hide-on-desktop">
                                500
                            </div>
                            <div className="hide-on-mobile">
                                500
                            </div>
                        </th>
                        <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                            <div className="hide-on-desktop">
                                3000
                            </div>
                            <div className="hide-on-mobile">
                                3000
                            </div>
                        </th>
                        <th style={{ textAlign: "right", verticalAlign: "bottom", paddingLeft: "10px" }}>
                            <div style={{ lineHeight: "1em", fontSize: "1.5em" }}>
                                {'∞'}
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th className={this.setEvaluationColor(evalColorValue)} style={{ textAlign: "left", verticalAlign: "bottom", paddingLeft: "10px" }}>{midCapText}</th>
                        <td></td>
                        <td className="micro-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "micro-ess-evaluation": msp > 0, "is-start": msp > 0, "is-end": smallMidCap === 0 })}>
                                <Translate id="Report.EconomicGroup.MSP.MSP" />
                            </div>
                        </td>
                        <td className="small-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "small-ess-evaluation": smallMidCap > 0, "is-start": smallMidCap > 0 && midCap > 0, "is-end": msp > 0 && midCap === 0 })}>
                                <Translate id="Report.EconomicGroup.MSP.SmallMidCap" />
                            </div>
                        </td>
                        <td className="medium-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "medium-ess-evaluation": midCap > 0, "is-start": midCap > 0 && notMidCap > 0, "is-end": smallMidCap > 0 && notMidCap === 0 })}>
                                <Translate id="Report.EconomicGroup.MSP.MidCap" />
                            </div>
                        </td>
                        <td className="large-ess-column">
                            <div className={classnames({ "final-evaluation-column": true, "large-ess-evaluation": notMidCap > 0, "is-start": midCap === 0, "is-end": midCap > 0 })}>
                                <Translate id="Report.EconomicGroup.MSP.NotMidCap" />
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td className="ess-table-evaluation">
                            {parseFloat(msp).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(smallMidCap).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(midCap).toFixed(2) + "%"}
                        </td>
                        <td className="ess-table-evaluation">
                            {parseFloat(notMidCap).toFixed(2) + "%"}
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    setEvaluationColor = (large) => {
        if (large === 0)
            return ("evaluation-isNotSME")
        else if (large === 1)
            return ("evaluation-isSME")
        else
            return ("evaluation-probablySME")
    }

    isSME = (large) => {
        if (large === 0)
            return (<Translate id="Report.EconomicGroup.SME.Sme" />)
        else if (0 < large && large < 0.5)
            return (<Translate id="Report.EconomicGroup.SME.probablySme" />)
        else if (0.5 <= large && large < 1)
            return (<Translate id="Report.EconomicGroup.SME.probablyNotSme" />)
        else
            return (<Translate id="Report.EconomicGroup.SME.NotSme" />)
    }

    setSizeOfLastSlider = (min, max, minLimit, maxLimit, start, coef, shift) => {

        let width = 0;
        let margin = 0;

        let lowerLimit = Math.max(min, minLimit);
        let upperLimit = Math.min(max, maxLimit);

        if (upperLimit > minLimit) {
            var maxs = Math.log(upperLimit - start) / coef - shift;
            var mins = Math.log(lowerLimit - start) / coef - shift;
            width = maxs - mins;
            margin = mins;

            if (!(min > maxLimit || max <= minLimit) || (max === 0 && minLimit === 0)) {
                if (margin > 97)
                    margin = 97;

                width = Math.max(3, width + 1);
            }
        }

        return ({ width: `${width}%`, marginLeft: `${margin}%`, borderBottomLeftRadius: minLimit >= min ? "0" : "1em", borderTopLeftRadius: minLimit >= min ? "0" : "1em", borderBottomRightRadius: "1em", borderTopRightRadius: "1em" })
    }

    setSizeOfSlider = (min, max, minLimit, maxLimit) => {
        let margin = this.setMargin(min, minLimit, maxLimit);
        let width = 0;

        let upperLimit = Math.min(max, maxLimit);

        var end = this.setMargin(upperLimit, minLimit, maxLimit);

        if (!(min > maxLimit || max <= minLimit) || (max === 0 && minLimit === 0)) {
            if (margin > 97)
                margin = 97;

            width = Math.max(3, end - margin + 1);
        }
        return ({ width: `${width}%`, marginLeft: `${margin}%`, borderBottomLeftRadius: minLimit !== 0 ? minLimit >= min ? "0" : "1em" : "1em", borderTopLeftRadius: minLimit !== 0 ? minLimit >= min ? "0" : "1em" : "1em", borderBottomRightRadius: maxLimit <= max ? "0" : "1em", borderTopRightRadius: maxLimit <= max ? "0" : "1em" })
    }

    setMargin = (min, minLimit, maxLimit) => {
        if (min > minLimit && min <= maxLimit && minLimit !== maxLimit) {
            var margin = (min - minLimit) / (maxLimit - minLimit) * 100;
            return margin;
        }

        return 0;
    }

    shortNumber = (number, decPlaces) => {
        decPlaces = Math.pow(10, decPlaces);
        var abbrev = ["K", "M", "B", "T"];

        for (var i = abbrev.length - 1; i >= 0; i--) {
            var size = Math.pow(10, (i + 1) * 3);
            if (size <= number) {
                number = Math.round(number * decPlaces / size) / decPlaces;
                if ((number === 1000) && (i < abbrev.length - 1)) {
                    number = 1;
                    i++;
                }
                number += abbrev[i];
                break;
            }
        }
        return number;
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(EconomicGroupSme));
